import styled, { css } from 'styled-components';
import {
	ApModal as ApModalUnstyled,
	ApButtonSecondary as ApButtonSecondaryUnstyled,
} from '@alixpartners/ui-components';
import {
	black,
	greenLight2,
	lightestRed,
	chartDarkGray,
	grey30,
	grey150,
	grey400,
	redBright,
} from 'styles/colors';

export const VendorsList = styled.ul`
	margin-bottom: 16px;
	user-select: none;
`;

export const ActiveList = styled.ul`
	background: ${({ isDeleting }) => (isDeleting ? lightestRed : grey30)};

	&:last-child {
		border-bottom: 1px solid ${grey150};
	}
`;

export const VendorsListCell = styled.span`
	width: 40%;
	height: 40px;
	padding-left: 30px;
	display: inline-block;
	&:first-child {
		padding-left: 8px;
	}
	&:last-child {
		width: 200px;
		padding-left: 12px;
		display: none;
	}
	&:nth-child(2) {
		width: calc(60% - 200px);
	}
`;

export const NegativeVendorsListCell = styled.span`
	width: 25%;
	height: 40px;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
	padding-left: 30px;
	display: inline-block;
	&:first-child {
		padding-left: 8px;
	}
`;

const RowHoverStyles = css`
	cursor: pointer;
	&:hover {
		background: ${grey150};

		${VendorsListCell}:last-child {
			display: inline-block;
		}
	}
	${VendorsListCell}:last-child {
		display: ${({ isEditing, isDeleting }) =>
			isEditing || isDeleting ? 'block' : 'none'};
	}
`;

export const VendorsListRow = styled.li`
	display: flex;
	height: 40px;
	line-height: 40px;
	border-bottom: 1px solid ${grey150};
	background: ${({ isActive, isDeleting }) =>
		isDeleting ? lightestRed : isActive ? grey30 : 'none'};
	${({ negativeList }) =>
		negativeList ? null : RowHoverStyles} ${ActiveList} + & {
		border-top: 1px solid ${grey150};
	}
`;

export const VendorsListHeader = styled(VendorsListRow)`
	text-transform: uppercase;
	color: ${chartDarkGray};
	font-size: 11px;
	letter-spacing: 0.8px;

	height: 21px;
	line-height: 13px;
	&:hover {
		background: none;
	}
`;

export const Button = styled.button.attrs({
	type: 'button',
})`
	outline: none;
	border: 0;
	background: transparent;
	height: 40px;
	display: inline-flex;
	align-items: center;
	padding-right: 22px;
	cursor: pointer;
	color: ${black};
	svg {
		color: ${grey400};
		position: relative;
		top: -1px;
	}
	transition: color 200ms ease-out;
`;

export const ButtonDelete = styled(Button)`
	padding-right: 16px;
	color: ${redBright};
	svg {
		color: ${redBright};
	}
`;

export const ButtonCancel = styled(Button)`
	padding-right: 14px;
	padding-left: 1px;
`;

export const ButtonSave = styled(Button)`
	color: ${greenLight2};
	svg {
		color: ${greenLight2};
	}
`;

export const ButtonText = styled.span`
	height: 40px;
	line-height: 40px;
	display: inline-block;
	padding-left: 4px;
	text-transform: uppercase;
	font-size: 13px;
`;

export const ActiveRow = styled.li`
	display: flex;
	height: 57px;
	line-height: 40px;
	margin: 0 24px;
	border-bottom: 1px solid ${grey150};
	background: ${({ isActive }) => (isActive ? grey30 : 'none')};
	&:last-child {
		border-bottom: none;
	}
`;

export const ActiveRowCell = styled.span`
	width: calc(25% - 8px);
	height: 40px;
	padding-left: 30px;
	display: inline-block;
	margin-top: 12px;

	&:first-child {
		padding-left: 0;
	}
`;

export const ActiveRowCellTitle = styled.div`
	height: 13px;
	line-height: 13px;
	color: ${chartDarkGray};
	font-size: 11px;
	letter-spacing: 0;
`;

export const ActiveRowCellValue = styled.div`
	height: 24px;
	line-height: 19px;
	color: ${black};
	font-size: 13px;
	letter-spacing: 0.3px;
	padding-top: 4px;

	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
`;

export const ModalBody = styled.div`
	display: flex;

	> span {
		margin: 26px 0 22px 17px;
		width: 400px;
	}
`;
export const ApButtonSecondary = styled(ApButtonSecondaryUnstyled)`
	margin-right: 16px;
`;

export const ApModal = styled(ApModalUnstyled)`
	& .ap-modal-content {
		max-width: ${({ width }) => (width ? `${width}px` : '')};
	}
`;

export const SubsectionTitle = styled.div`
	display: block;
	width: 100%;
	font-size: 19px;
	font-weight: 500;
	letter-spacing: normal;
	line-height: 27px;
	color: ${black};
	margin: 48px 0 35px 0;
`;
